export { default as Products } from "./views/Products"
export { default as ProdBycategory } from "./views/ProdBycategory"
export { default as SingleProduct } from "./views/SingleProduct"
export { default as CheckOut } from "./views/CheckOut"
export { default as ShopCart } from "./views/ShopCart"
export { default as ShopFav } from "./views/ShopFav"
export { default as OrdersShop } from "./views/OrdersShop"
export { default as OrdersShopAdmin } from "./views/OrdersShopAdmin"
